export default "__VITE_ASSET__10b5d6c0__"